var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityDefaultBanner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 140,
    viewBox: "0 0 360 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 140,
    x: 0,
    y: 0,
    fill: "#528be8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 267.5,85 C 172.90074,85 107.89905,123.08857 83.666016,140 H 360 V 97.55078 C 335.48629,90.15989 305.11597,85 267.5,85 Z",
    fill: "#78a4ec"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 55.214844,95 C 35.32627,95 16.945475,97.48949 0,101.69141 V 140 H 205.28711 C 162.69083,116.87053 108.02967,95 55.214844,95 Z",
    fill: "#74c0d3",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityDefaultBanner);
export default __webpack_public_path__ + "static/media/community_default_banner.4bfb7ce6f8e9f59a8cb60e51d86a3bab.svg";
export { ForwardRef as ReactComponent };